import script from "./Referral.vue?vue&type=script&setup=true&lang=js"
export * from "./Referral.vue?vue&type=script&setup=true&lang=js"

import "./Referral.vue?vue&type=style&index=0&id=30d5d04e&lang=scss"

const __exports__ = script;

export default __exports__